/**
 * SITE-EDIT-MODAL
 * Edit site
 */
import Modal from "@/components/modal"
import TextInput from "@/components/text-input"
import siteStore from "../../model/site.store"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { useState } from "react"
import SiteDeleteModal from "./SiteDeleteModal"
import populationStore from "@/entities/population/model/population.store"
import PhysicalRiskUnitsSelector, {
  PhysicalRiskUnitContext
} from "@/entities/physical-risk/ui/PhysicalRiskUnitsSelector"

interface Props {
  onClose: () => void
}

export default function SiteEditModal(props: Props) {
  const dispatch = useAppDispatch()

  //Selectors
  const draftSite = useAppSelector(siteStore.selectors.draft)
  const status = useAppSelector(siteStore.selectors.status)
  const sitePopulations = useAppSelector(populationStore.selectors.listForSite)

  //State
  const [modal, setModal] = useState<null | "MODAL_REMOVE">(null)

  //Save modifications
  async function save() {
    const response = await dispatch(siteStore.thunks.updateEntity()).unwrap()
    if (response) {
      props.onClose()
    } else {
      setModal(null)
    }
  }

  function handlePopulationSelect(unit: PhysicalRiskUnitContext) {
    if (unit.type !== "population") return
    const isSelected = draftSite.populationIds.includes(unit.population.id)
    dispatch(
      siteStore.actions.edit({
        key: "populationIds",
        value: isSelected
          ? draftSite.populationIds.filter((id) => id !== unit.population.id)
          : draftSite.populationIds.concat(unit.population.id)
      })
    )
  }

  return (
    <Modal
      status={status}
      onDelete={() => setModal("MODAL_REMOVE")}
      onClose={() => {
        dispatch(siteStore.actions.cancel())
        props.onClose()
      }}
      title={"Mettre à jour lieu de travail"}
      isLarge
      isCloseButtonVisible
      onNext={() => save()}>
      {modal === "MODAL_REMOVE" && <SiteDeleteModal onClose={() => props.onClose()} />}

      <TextInput
        title="Nom du lieu"
        value={draftSite.name}
        onChange={(e) => dispatch(siteStore.actions.edit({ key: "name", value: e.value }))}
      />

      <div className="h-10" />

      <PhysicalRiskUnitsSelector
        isMulti
        unitType="population"
        selectedUnits={sitePopulations.map((population) => ({ type: "population" as const, population }))}
        onSelect={handlePopulationSelect}
      />

      <div className="h-40" />
    </Modal>
  )
}
